import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'search-suggestions-view';

/**
 * This is the search suggestions view event

1. Container name and 0-indexed container position (separated by |)
2. Request ID
3. Query and suggestions (all separated by |)
*/
export function trackSearchSuggestionsView(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
